<template>
  <div
    class="dt-calendar-container"
    @scroll="onCalendarContainerScroll"
    ref="calendarContainer"
    @wheel="onCalendarContainerWheel"
  >
    <!-- <div
      class="temp"
      v-if="showTemp"
      style="
        position: absolute;
        z-index: 9999;
        background: linear-gradient(
          rgba(62, 60, 60, 0.5),
          rgba(146, 142, 142, 0.4),
          rgba(148, 145, 145, 0.35)
        );
        color: #552323;
        padding: 12px;
        font-size: 40px;
        top: 15px;
        right: 10px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
        border-radius: 10px;
      "
    >
      {{ getGMTOffsetText(selectedMonthDate) }}
    </div> -->
    <div class="dt-calendar">
      <div class="dt-calendar--week weekdays">
        <div
          class="dt-calendar--day weekday ut-cap"
          v-for="day of calendarGrid[0]"
          :key="JSON.stringify(day)"
        >
          {{ $t(getWeekName(day)) }}
        </div>
      </div>
    </div>
    <div ref="calendar" id="calel" class="dt-calendar main">
      <div
        class="dt-calendar--week"
        v-for="(week, weekIndex) in calendarGrid"
        :key="JSON.stringify(week)"
        :style="getWeekStyle(weekIndex, weekRangesD)"
      >
        <div class="dt-calendar--week-range">
          <div
            class="dt-calendar--event-item"
            v-for="event in weekRangesD[weekIndex]"
            :key="JSON.stringify(event)"
            :style="getEventRangeStyle(event)"
            @click="(e) => onEventRangeClick(event)"
            @mouseenter="(e) => OnEventRangeMouseEnter(event)"
            @mouseleave="(e) => OnEventRangeMouseLeave(event)"
            :class="{
              hover: event.PRIMARY_KEY === hoveredBooking,
            }"
          >
            <div
              v-if="event.rightIndex === event.leftIndex"
              class="dt-calendar--item__color"
              :style="getEventColorStyle(event)"
            >
              <div class="box"></div>
            </div>
            <div
              class="dt-calendar--item__label"
              :style="{
                'margin-left':
                  event.rightIndex > event.leftIndex ? '14px' : '0',
              }"
            >
              <!-- {{getEventTitle(getEventByPrimaryKey(event.PRIMARY_KEY))}} -->
              {{ getEventTitle(event) }}
              <!-- {{event}} -->
            </div>
          </div>
        </div>

        <div
          class="dt-calendar--day"
          v-for="day in week"
          :key="JSON.stringify(day)"
          :class="{
            selected: isSelected(day),
            animating: isAnimating(day),
          }"
        >
          <div
            class="dt-calendar--label"
            :class="{
              current: isCorrentMonth(day),
            }"
            @click="onAddEventClick(day)"
          >
            <div
              class="dt-calendar--label-month"
              style="text-transform: capitalize"
              v-if="isFirstDayOfMonth(day)"
            >
              {{ firstDayOfMonthText(day) }}
            </div>
            <div
              class="dt-calendar--label-text"
              :class="{
                today: isToday(day),
              }"
            >
              <!-- <pre style="font-size: 10px">{{adjustToLocal(day).toISOString()}} L:{{adjustToLocal(day).getDate()}} U:{{adjustToLocal(day).getUTCDate()}} </pre> -->
              <!-- {{ adjustToLocal(day).getDate() }} -->
              {{ day.getUTCDate() }}
            </div>
            <div class="dt-calendar--label-button ut-flex">
              <div class="add-new-date-button">+ {{ $t("add_new_date") }}</div>
              <div class="available-artist-icon-button">
                <IconButton
                  @click.stop="(e) => onAvailableArtistsClick(day)"
                  bcHover="sprt-8"
                  :size="12"
                  :padding="2"
                  :icon="`available-artists`"
                />
              </div>
            </div>
          </div>
          <!-- <div class="dt-calendar--items">
            <div 
              class="dt-calendar--item"
              v-for="event of getBookingArtists(day)"  
              :key="event.PRIMARY_KEY"

              @click="e =onEventClick(event)"
            >
              <div class="dt-calendar--item__color">
                <div
                  class="box"
                  :style="{
                    'backgroundColor': `#${event.booking_status_colour}`
                  }"
                >
                </div>
              </div>
              <div class="dt-calendar--item__label">
                {{event.artist_name}} {{event.city ? `- ${event.city}` : ''}} {{event.booking_location_name ? `- ${event.booking_location_name}` : ''}}
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWithinRange, differenceInDays, format, isSameDay } from "date-fns";
import {
  getCalendarGrid,
  within,
  invertColor,
  debounceSubject,
  sendMailHref,
} from "../../../utility";
import {
  BookingArtist,
  CalendarStack,
  fromExternalDateToBooking,
  EXTERNAL_CALENDAR_DATE,
} from "../models/booking-artist.model";
import { createRangeObject } from "../models/calendar-range.model";
import Color from "color";
import { Subject } from "rxjs";
import {
  adjustToLocal,
  getDefaultDateString,
  getGMTOffsetText,
  getWeekdayIndddFormat,
  parseUTCDate,
  getMonthInMMMMFormat,
} from "../../../utility/calendar";

export const EVENT_ITEM_HEIGHT = 20;
export const EVENT_ITEM_MARGIN = 3;
export const EVENT_ITEM_OFFSET_TOP = 27;
export const EVENT_ITEM_OFFSET_BOTTOM = 5;
export const DAYS_PER_WEEK = 7;
export const WEEK_START_ON = 0;
export const EVENT_RANGE_LEFT_OFFSET_PERC = 0.4;
export const EVENT_RANGE_RIGHT_OFFSET_PERC = 0.2;

import { range, identity } from "ramda";
import { openModalRoute2 } from "../../../dt-plugins/modal/modal.mixin";
import { BookingService } from "../services/booking-service";

export default {
  props: {
    selectedDateBox: {
      type: Date,
    },
    selectedMonth: {
      type: String,
      required: true,
    },
    bookingArtistList: {
      type: Array,
    },
    showExternalCalendar: {
      type: Boolean,
      default: false,
    },
    externalDates: {
      type: Array,
      default: [],
    },
    statusColorMap: {
      type: Object,
    },
  },
  mounted: async function () {
    debounceSubject(
      this,
      this.previousSubject,
      (prev) => {
        this.$emit("prev_month", true);
      },
      200
    );
    debounceSubject(
      this,
      this.nextSubject,
      (next) => {
        this.$emit("next_month", true);
      },
      200
    );
  },
  data: function () {
    return {
      today: new Date(),
      demoBookingArtistList: [
        BookingArtist.create({
          artist_id: "123",
          calendar_date_id: "456",
          booking_status_colour: "F2CF07",
          city: "London",
          artist_name: "John Lennon",
          booking_location_name: "The O2",

          start_date: "2019-01-2",
          end_date: "2019-01-4",
        }),
      ],
      weekRanges: [
        [
          {
            PRIMARY_KEY: "123__456",
            topIndex: 0,
            leftIndex: 3,
            rightIndex: 5,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 1,
            leftIndex: 1,
            rightIndex: 5,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 2,
            leftIndex: 2,
            rightIndex: 6,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 3,
            leftIndex: 2,
            rightIndex: 6,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 4,
            leftIndex: 0,
            rightIndex: 3,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 5,
            leftIndex: 4,
            rightIndex: 6,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 6,
            leftIndex: 0,
            rightIndex: 6,
          },
        ],
        [
          {
            PRIMARY_KEY: "123__456",
            topIndex: 0,
            leftIndex: 2,
            rightIndex: 6,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 1,
            leftIndex: 0,
            rightIndex: 3,
          },
          {
            PRIMARY_KEY: "123__456",
            topIndex: 2,
            leftIndex: 4,
            rightIndex: 6,
          },
        ],
      ],
      calendarStack: CalendarStack.create(),
      weekdaysScrollSpacer: `0px`,

      hoveredBooking: null,

      previousBuffer: 0,
      nextBuffer: 0,

      previousSubject: new Subject(),
      nextSubject: new Subject(),

      animatingDate: null,
      animationStopper: null,
    };
  },
  watch: {
    selectedDateBox: {
      immediate: true,
      handler: function (to, from) {
        if (to) {
          this.setAnimation(to);
        }
      },
    },
  },
  computed: {
    showTemp() {
      return this.$store.getters.account.user.user_name == "details_helper";
    },
    selectedMonthDate: function () {
      const year = +this.selectedMonth.split("-")[0];
      const month = +this.selectedMonth.split("-")[1] - 1;
      const date = 1;
      // return new Date(`${this.selectedMonth}-01T00:00:00${getTimezoneOffsetString()}`);
      // return new Date(`${this.selectedMonth}-01T00:00:00Z`);
      // return new Date(year, month, date);
      return parseUTCDate(`${this.selectedMonth}-01`);
    },
    calendarGrid: function () {
      // console.log({sm: this.selectedMonth, 'calendar.vue:324 this.selectedMonthDate' : this.selectedMonthDate, tz: getTimezoneOffsetString()});
      return (
        this.selectedMonth &&
        getCalendarGrid(this.selectedMonthDate, {
          weekStartsOn: 1,
          dayPerWeek: 7,
          weekCount: 6,
        })
      );
    },
    weekRangesD: function () {
      // console.log("RECALC WEEKRANGE START");
      const bookingArtistListWithCalendar =
        this.bookingArtistWithExternalCalendar;

      this.calendarStack = CalendarStack.create(
        bookingArtistListWithCalendar.length
      );

      const weekRangesD = this.calendarGrid.map((week, weekIndex) => {
        const renderedEvents = [];
        return week
          .reduce((accm, day, dayIndex) => {
            // if (day.getDate() == 13) {
            //   debugger;
            // }

            const distanceMap = BookingArtist.without(
              renderedEvents,
              bookingArtistListWithCalendar
            )
              .filter((booking) => {
                // Range Calculation Causes Problem in Time where Time Zones are Declared Differently

                // ^\d{4}-\d{1,2}-\d{1,2}$

                let start_date = booking.start_date;
                let end_date = booking.end_date;

                // if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(end_date)) {
                //   end_date = `${end_date}T23:59:59Z`;
                // }
                // if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(end_date)) {
                //   start_date = `${start_date}T00:00:00Z`;
                // }

                try {
                  // const isInRange = isWithinRange(day, start_date, end_date);
                  const isInRange = isWithinRange(
                    day,
                    parseUTCDate(start_date),
                    parseUTCDate(end_date)
                  );
                  // if (day.getUTCDate() == 7 && start_date == "2023-04-07") {
                  //   console.log("rangeCalc d", {
                  //     day,
                  //     start_date,
                  //     end_date,
                  //     isInRange,
                  //     usd: parseUTCDate(start_date),
                  //     ued: parseUTCDate(end_date),
                  //     selectedMonthDate: this.selectedMonthDate,
                  //     selectedMonth: this.selectedMonth,
                  //   });
                  // }
                  if (
                    booking.PRIMARY_KEY == "37__4821" &&
                    day.getDate() == 31
                  ) {
                    console.error({ booking, day, isInRange });
                  }
                  // console.log({ booking, day, isInRange });

                  return isInRange;
                } catch (e) {
                  if (
                    e.message ===
                    `The start of the range cannot be after the end of the range`
                  ) {
                    console.error(
                      `Calendar Date - ${booking.calendar_date_id} has a Start Date: ${booking.start_date} After the End Date: ${booking.end_date}`,
                      booking
                    );
                    // booking.end_date = booking.start_date;
                    // return isWithinRange(day, booking.start_date, booking.start_date);
                    return false;
                  }
                  return false;
                }
              })
              .map((booking) => {
                const bookingWeight =
                  differenceInDays(day, booking.start_date) +
                  differenceInDays(booking.end_date, day) / 2;
                if (booking.PRIMARY_KEY == "37__4821") {
                  console.error({ booking, bookingWeight: bookingWeight });
                }
                // console.log({ booking, bookingWeight: bookingWeight });
                return {
                  PRIMARY_KEY: booking.PRIMARY_KEY,
                  start_date: booking.start_date,
                  end_date: booking.end_date,

                  artist_name: booking.artist_name,
                  city: booking.city,
                  booking_location_name: booking.booking_location_name,
                  booking_status_name: booking.booking_status_name,

                  weight: bookingWeight,
                };
              })
              .filter((e) => e.weight >= 0)
              .sort((a, b) => b.weight - a.weight);

            // distanceMap && distanceMap.length > 0 && console.log(distanceMap);

            const dayEvents = distanceMap
              .map((booking) => {
                if (!renderedEvents.includes(booking.PRIMARY_KEY)) {
                  renderedEvents.push(booking.PRIMARY_KEY);
                  const leftIndex = dayIndex;
                  const rightIndex = within(
                    6,
                    dayIndex,
                    differenceInDays(new Date(booking.end_date), day) + dayIndex
                  );

                  const topIndex = CalendarStack.next(
                    this.calendarStack,
                    weekIndex,
                    dayIndex
                  );
                  this.calendarStack = CalendarStack.populate(
                    this.calendarStack,
                    weekIndex,
                    topIndex,
                    leftIndex,
                    rightIndex
                  );

                  // const topIndex = topStack[weekIndex][dayIndex];
                  // console.log(booking);
                  return createRangeObject({
                    PRIMARY_KEY: booking.PRIMARY_KEY,
                    topIndex,
                    leftIndex,
                    rightIndex,

                    ...booking,
                  });
                }
              })
              .filter(identity);
            // console.log({ dayEvents: dayEvents });
            accm = [...accm, ...dayEvents];
            return accm;
          }, [])
          .filter(identity);
      });
      // console.log({ bookingArtistListWithCalendar, weekRangesD });
      return weekRangesD;
    },
    bookingArtistWithExternalCalendar: function () {
      // console.log({
      //   bookingArtistWithExternalCalendar: this.bookingArtistList,
      //   showExternalCalendar: this.showExternalCalendar,
      // });
      if (this.showExternalCalendar) {
        return [...this.bookingArtistList, ...this.externalDatesOrganized];
      } else {
        return this.bookingArtistList;
      }
    },
    externalDatesOrganized: function () {
      return this.externalDates.map(fromExternalDateToBooking);
    },
  },
  methods: {
    getGMTOffsetText: getGMTOffsetText,
    adjustToLocal: adjustToLocal,
    getWeekName: function (date) {
      // let offsetMilliseconds = getTimezoneOffsetMilliseconds(date);
      // if (offsetMilliseconds >= 0) {
      //   offsetMilliseconds *= -1;
      // }
      // const adjustedDate = new Date(date.getTime() + offsetMilliseconds);

      // return adjustedDate;
      // console.log({'getWeekName adjustedDate' : adjustedDate, date, offsetMilliseconds});
      // return format(adjustToLocal(date), "ddd").toLowerCase();
      return getWeekdayIndddFormat(date);
    },
    isCorrentMonth: function (date) {
      // console.log({'calendar.vue:546 date' : date});
      // console.log({'calendar.vue:548 this.selectedMonthDate' : this.selectedMonthDate});
      // date = adjustToLocal(date);
      // console.log('isCurrentMonth', {
      //   date,
      //   selectedMonthDate: this.selectedMonthDate,
      //   isSameMonth: date.getUTCMonth() == this.selectedMonthDate.getUTCMonth(),
      //   isSameYear: date.getUTCFullYear() == this.selectedMonthDate.getUTCFullYear(),
      //   utcMonth: date.getUTCMonth(),
      //   utcYear: date.getUTCFullYear(),
      //   smonth: this.selectedMonthDate.getMonth(),
      //   syear: this.selectedMonthDate.getFullYear(),
      // });
      return (
        date.getUTCMonth() == this.selectedMonthDate.getUTCMonth() &&
        date.getUTCFullYear() == this.selectedMonthDate.getUTCFullYear()
        // date.getUTCMonth() == this.selectedMonthDate.getUTCMonth() &&
        // date.getUTCFullYear() == this.selectedMonthDate.getUTCFullYear()
      );
    },
    isToday: function (date) {
      date = adjustToLocal(date);
      if (
        date.getMonth() == this.today.getMonth() &&
        date.getDate() == this.today.getDate() &&
        date.getYear() == this.today.getYear()
      ) {
        // console.log({'calendar.vue:582 this.today' : this.today, date});
      }
      return (
        date.getMonth() == this.today.getMonth() &&
        date.getDate() == this.today.getDate() &&
        date.getYear() == this.today.getYear()
      );
    },
    getBookingArtists: function (date) {
      return this.demoBookingArtistList.filter((e) =>
        isSameDay(new Date(e.start_date), date)
      );
    },
    onEventClick: function (event) {
      this.$emit("eventClicked", event);
    },
    onEventRangeClick: function (event) {
      this.$emit("eventClicked", {
        ...event,
        ...this.getEventByPrimaryKey(event.PRIMARY_KEY),
      });
    },
    getWeekStyle: function (index, weekRanges = this.weekRangesD) {
      if (
        weekRanges[index] &&
        weekRanges[index].length &&
        weekRanges[index].length > 0
      ) {
        const eventsCount = CalendarStack.weekHeight(this.calendarStack, index);
        const minHeight =
          eventsCount * EVENT_ITEM_HEIGHT +
          eventsCount * EVENT_ITEM_MARGIN +
          EVENT_ITEM_OFFSET_TOP +
          EVENT_ITEM_OFFSET_BOTTOM;
        return {
          minHeight: `${minHeight < 135.67 ? 135.67 : minHeight}px`,
        };
      } else {
        return {
          minHeight: `135.67px`,
        };
      }
    },
    getEventRangeStyle: function (event, list = this.bookingArtistList) {
      // const eventObj = this.getEventByPrimaryKey(event.PRIMARY_KEY, list);
      const eventObj = event;

      // console.log(Color(this.getBookingStatusColor(eventObj.booking_status_name)).lighten(0.2).string());

      return {
        ...(event.rightIndex > event.leftIndex && {
          backgroundColor: `${this.getBookingbackgroundColor(eventObj)}`,
          color: invertColor(
            `${this.getBookingStatusColor(eventObj.booking_status_name)}`,
            true
          ),
        }),

        height: `${EVENT_ITEM_HEIGHT}px`,
        width: `${
          ((event.rightIndex - event.leftIndex + 1) / DAYS_PER_WEEK) * 100 -
          EVENT_RANGE_LEFT_OFFSET_PERC
        }%`,
        left: `${
          (event.leftIndex / DAYS_PER_WEEK) * 100 +
          EVENT_RANGE_RIGHT_OFFSET_PERC
        }%`,
        top: `${
          event.topIndex * EVENT_ITEM_HEIGHT +
          event.topIndex * EVENT_ITEM_MARGIN +
          EVENT_ITEM_OFFSET_TOP
        }px`,
      };
    },
    getBookingbackgroundColor: function (eventObj) {
      if (eventObj.PRIMARY_KEY == this.hoveredBooking) {
        return Color(this.getBookingStatusColor(eventObj.booking_status_name))
          .lighten(0.2)
          .string();
      } else {
        return this.getBookingStatusColor(eventObj.booking_status_name);
      }
    },
    getEventColorStyle: function (event, list = this.bookingArtistList) {
      // const eventObj = this.getEventByPrimaryKey(event.PRIMARY_KEY, list);
      const eventObj = event;
      return {
        backgroundColor: `${this.getBookingStatusColor(
          eventObj.booking_status_name
        )}`,
      };
    },
    getEventByPrimaryKey: function (
      PRIMARY_KEY,
      list = this.bookingArtistList
    ) {
      // console.log(this.demoBookingArtistList, PRIMARY_KEY);
      // console.log('GetByPk', PRIMARY_KEY);
      return list.find((e) => e.PRIMARY_KEY == PRIMARY_KEY);
    },
    getEventTitle: function (event) {
      return event
        ? event.booking_status_name != EXTERNAL_CALENDAR_DATE
          ? `${event.artist_name} ${event.city ? `- ${event.city}` : ""} ${
              event.booking_location_name
                ? `- ${event.booking_location_name}`
                : ""
            }`
          : `${event.artist_name} ${
              event.booking_location_name
                ? `- ${event.booking_location_name}`
                : ""
            }`
        : "UNDEFINED_EVENT";
    },
    onAddEventClick: function (day) {
      this.$emit("eventAdd", {
        start_date: format(day, "YYYY-MM-DD"),
      });
    },
    isFirstDayOfMonth: function (day) {
      return day.getUTCDate() === 1;
    },
    firstDayOfMonthText: function (day) {
      // console.log({'calendar.vue:697 day' : day, al: adjustToLocal(day)});
      // return format(adjustToLocal(day), "MMM");

      return this.$t(getMonthInMMMMFormat(day))?.slice(0, 3);
    },
    OnEventRangeMouseEnter: function (event) {
      // console.lo(event);
      this.hoveredBooking = event.PRIMARY_KEY;
    },
    OnEventRangeMouseLeave: function (event) {
      this.hoveredBooking = null;
    },

    onCalendarContainerScroll: function (event) {},
    onCalendarContainerWheel: function (event) {
      // const element = this.$refs["calendarContainer"];
      // console.log({ scrollTop: element.scrollTop });
      // if (element.scrollHeight > element.clientHeight) {
      //   setTimeout(() => {
      //     const scrollBottom = element.scrollTop + element.clientHeight;
      //     if (scrollBottom == element.scrollHeight || element.scrollTop == 0) {
      //       if (scrollBottom == element.scrollHeight) {
      //         this.nextMonth();
      //       }
      //       if (element.scrollTop == 0) {
      //         this.previousMonth();
      //       }
      //     } else {
      //       this.resetNav();
      //     }
      //   }, 200);
      // } else {
      //   if (event.deltaY > 0) {
      //     this.nextMonth();
      //   } else {
      //     this.previousMonth();
      //   }
      // }
    },
    resetNav: function () {
      // console.log("Resetting Nav", this.previousBuffer, this.nextBuffer);
      this.previousBuffer = 0;
      this.nextBuffer = 0;
    },
    previousMonth: function (immediate) {
      // console.log("Previous Nav", this.previousBuffer, this.nextBuffer);
      if (this.previousBuffer >= 1 || immediate) {
        this.previousSubject.next(true);
        this.resetNav();
      } else {
        this.previousBuffer += 1;
      }
    },
    nextMonth: function (immediate) {
      // console.log("Next Nav", this.previousBuffer, this.nextBuffer);
      if (this.nextBuffer >= 1 || immediate) {
        this.nextSubject.next(true);
        this.resetNav();
      } else {
        this.nextBuffer += 1;
      }
    },
    getBookingStatusColor: function (booking_status_name) {
      return this.statusColorMap[booking_status_name] || "#FFFFFF";
    },
    isSelected: function (day) {
      if (this.selectedDateBox) {
        return isSameDay(this.selectedDateBox, day);
      } else {
        return false;
      }
    },
    isAnimating: function (day) {
      if (this.animatingDate) {
        return isSameDay(this.animatingDate, day);
      } else {
        return false;
      }
    },
    setAnimation: function (to) {
      let animDuration = 400;
      if (this.animatingDate) {
        this.animatingDate = null;
        clearTimeout(this.animationStopper);

        setTimeout(() => {
          this.animatingDate = to;
          this.animationStopper = setTimeout(() => {
            this.animatingDate = null;
          }, animDuration);
        }, 0);
      } else {
        this.animatingDate = to;
        this.animationStopper = setTimeout(() => {
          this.animatingDate = null;
        }, animDuration);
      }
    },
    async onAvailableArtistsClick(day) {
      // console.log("day", day);
      const dateString = getDefaultDateString(day);
      const artistsRes = await BookingService.findAvailableArtists({
        start_date: dateString,
      });
      // console.log({ artistsRes });
      const mailBody = artistsRes?.data
        ?.map((artist) => {
          const {
            booking_status_name,
            booking_location_name,
            artist_name,
            performance_type,
            url1,
            url2,
          } = artist;
          return artist_name
            ? `${artist_name}${
                booking_status_name
                  ? `(${booking_status_name}${
                      booking_location_name ? `,${booking_location_name}` : ""
                    })`
                  : ""
              }${performance_type ? ", " + performance_type : ""}${
                url1 ? "\n" + url1 : ""
              }${url2 ? "\n" + url2 : ""}`
            : null;
        })
        .filter((artist) => artist)
        .join("\n\n");

      // console.log({ mailBody });

      sendMailHref({
        subject: `${this.$t("available_artists")} on ${dateString}`,
        body: mailBody,
      });

      // openModalRoute2(this, "available_artists", {
      //   date: getDefaultDateString(day),
      // });
    },
    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.dt-calendar-container {
  .dt-calendar--day {
    &.selected {
      box-shadow: 0px 0px 6px 2px #0000005c;
    }
    &.animating {
      animation: rotatescale 400ms ease-out;
    }
    @keyframes rotatescale {
      50% {
        transform: scale(1.1) rotate(2deg) translateX(-10px);
      }
      100% {
        transform: scale(1) rotate(0) translateX(0);
      }
    }
  }
}
</style>
